module.exports = __webpack_public_path__ + "static/air_elemental-2c36920d3ae1bef9397748fdd7dbc27f.jpg";